import styled from 'styled-components'
import { media, colors } from './vars'
import { Element } from 'react-scroll'

const Title = styled.h2`
font-size:5rem;
font-weight:700;
line-height:.7;
${
    media.desktop`
    font-size:7rem;
    `
    }
`
const Subtitle = styled.h3`
font-size:3rem;
font-weight:700;
color:${colors.red};
transform:translate3d(-70px, 0, 0);

${
    media.desktop`
    font-size:4rem;
    transform:translate3d(-100px, 0, 0);
    `
    }
`
const Section = styled(Element) `
position:relative;
`
const StyledSection = styled(Section) `
background-repeat:no-repeat;
background-size:cover;
background-position:center;
`
export {
    Title,
    Subtitle,
    Section,
    StyledSection
}


// WEBPACK FOOTER //
// ./src/styles/elements.js